import { TrainingRegistrationDialog } from "views/lms/student/Registration/TrainingRegistrationDialog";

export const TrainingInfoDialog = ({ trainingId, onClose }: { trainingId: string; onClose: () => void; }) => {
    return <TrainingRegistrationDialog
        trainingId={trainingId}
        readonly
        onClose={onClose}
    />;
};
